"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var TextFields_1 = __importDefault(require("@material-ui/icons/TextFields"));

var Image_1 = __importDefault(require("@material-ui/icons/Image"));

var AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));

var Link_1 = __importDefault(require("@material-ui/icons/Link")); // import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';


var core_1 = require("@material-ui/core");

var action_row_component_1 = __importDefault(require("../action-row/action-row.component"));

var ActionListMenu = function ActionListMenu(_ref) {
  var anchorEl = _ref.anchorEl,
      handleClose = _ref.handleClose,
      handleSelectText = _ref.handleSelectText,
      handleSelectImage = _ref.handleSelectImage,
      handleSelectImageExplanation = _ref.handleSelectImageExplanation,
      handleSelectUrl = _ref.handleSelectUrl;

  var handleMenuClick = function handleMenuClick(fn) {
    return function () {
      fn();
      handleClose();
    };
  };
  /**
   * template 作成完了後、
   * template 挿入機能 アンコメント
   */


  return React.createElement(core_1.Menu, {
    id: "action-list-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, React.createElement(core_1.MenuItem, {
    onClick: handleMenuClick(handleSelectText)
  }, React.createElement(action_row_component_1.default, {
    Icon: TextFields_1.default,
    text: "\u30C6\u30AD\u30B9\u30C8\u3075\u304D\u3060\u3057"
  })), React.createElement(core_1.MenuItem, {
    onClick: handleMenuClick(handleSelectImage)
  }, React.createElement(action_row_component_1.default, {
    Icon: Image_1.default,
    text: "\u753B\u50CF\u3075\u304D\u3060\u3057"
  })), React.createElement(core_1.MenuItem, {
    onClick: handleMenuClick(handleSelectImageExplanation)
  }, React.createElement(action_row_component_1.default, {
    Icon: AddPhotoAlternate_1.default,
    text: "\u753B\u50CF\u8AAC\u660E\u3075\u304D\u3060\u3057"
  })), React.createElement(core_1.MenuItem, {
    onClick: handleMenuClick(handleSelectUrl)
  }, React.createElement(action_row_component_1.default, {
    Icon: Link_1.default,
    text: "URL"
  })));
};

exports.default = ActionListMenu;